import {
    $http
} from "@/assets/js/appFunc";
import {
    uid
} from "quasar";

export const getAllConsumedApis = (context) => {
    const applicationId = context.rootGetters["main/getCurrentApplicationId"];
    const params = {
        type: "GET",
        url: `/design/apis?applicationId=${applicationId}`,
        data: ""
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                if (context.state && context.state.allConsumedApis) {
                    context.commit("setAllConsumedApis", data.data);
                }
                resolve(data);
            },
            error => reject(error)
        );
    });
};

export const getAllSystemApis = (context) => {
    const applicationId = context.rootGetters["main/getCurrentApplicationId"];
    const params = {
        type: "GET",
        url: `/design/ws/system-apis?applicationId=${applicationId}`,
        data: ""
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                if (context.state && context.state.allInternalApis) {
                    context.commit("setAllInternalApis", data.data);
                }
                resolve(data);
            },
            error => reject(error)
        );
    });
};

export const getAllExposedApis = (context) => {
    const applicationId = context.rootGetters["main/getCurrentApplicationId"];
    const params = {
        type: "GET",
        url: `/design/credentials/app/${applicationId}`,
        data: ""
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                context.commit("setAllExposedApis", data);
                resolve(data);
            },
            error => reject(error)
        );
    });
};

export const getExposedClientIdSecret = (context, itemId) => {
    const applicationId = context.rootGetters["main/getCurrentApplicationId"];
    const params = {
        type: "GET",
        url: `/identity/oauth/util/app/${applicationId}/api/${itemId}/preview`,
        data: ""
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                resolve(data);
            },
            error => reject(error)
        );
    });
};

export const getAllStartFromExternal = (context) => {
    const data = {
        applicationId: context.rootGetters["main/getCurrentApplicationId"],
        type: "EXTERNAL_SOURCE_PLUGIN"
    };
    const params = {
        type: "GET",
        url: `/engine/api/processDefinition/activity/${data.applicationId}/${data.type}`,
        data: ""
    };
    $http(params, true).then(
        rsp => context.commit("setAllStartsFromExternal", rsp),
        error => console.log(error)
    );
};

export const deleteConsumedApi = (context, item) => {
    delete item.__index;
    const applicationId = context.rootGetters["main/getCurrentApplicationId"];
    const params = {
        type: "DELETE",
        url: `/design/apis/${item.id}?applicationId=${applicationId}`,
        data: ""
    };
    return $http(params, true);
};

export const refreshConsumedApi = (context, item) => {
    const applicationId = context.rootGetters["main/getCurrentApplicationId"];
    const params = {
        type: "GET",
        url: `/design/apis/${item.id}/refresh?applicationId=${applicationId}`,
        data: ""
    };
    $http(params, true).then(
        data => {
            context.commit("refreshConsumedApi", data.data);
            context.commit("setApiCommitId", data.data.commitId);
        },
        error => console.log(error)
    );
};
/* TO DO CHECK IF THIS NEEDED */
export const updateConsumedApi = (context, consumedAPis) => {
    const applicationId = context.rootGetters["main/getCurrentApplicationId"];
    const versionId = context.rootGetters["version/latestVersionId"];
    const params = {
        type: "PUT",
        url: "/integration/ws/update/multiple",
        data: consumedAPis.map(itemData => ({
            givenName: itemData.givenName || itemData.name,
            description: itemData.description,
            credentials: itemData.credentials,
            temporary: true,
            inEdit: true,
            applicationId,
            versionId,
            oldGivenName: itemData.oldGivenName,
            wsName: itemData.wsName,
            type: itemData.type,
            id: itemData.id,
            url: itemData.url
        }))
    };
    $http(params, true);
};

export const saveExposedApi = (context, item) => {
    const hadId = !!item.id;
    if (!hadId) {
        item.id = uid();
    }
    const params = {
        type: "POST",
        url: "/design/credentials",
        data: item
    };
    return $http(params, true);
};

export const deleteExposedApi = (context, item) => {
    const applicationId = context.rootGetters["main/getCurrentApplicationId"];

    delete item.__index;
    const params = {
        type: "DELETE",
        noNotify: true,
        url: `/design/credentials/app/${applicationId}/id/${item.id}`
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => {
                context.commit("deleteExposedApi", item);
                resolve(data);
            }
        )
            .catch(error => {
                reject(error);
            });
    });
};

export const saveConsumedApi = (context, payload) => {
    const params = {
        type: "POST",
        url: payload.descriptorCommitId ? `/design/apis/persist?update=${payload.update}&descriptorCommitId=${payload.descriptorCommitId}`
            : `/design/apis/persist?update=${payload.update}`,
        data: payload.bePayload
    };
    return $http(params, true);
};

export const downloadFile = (context, apiItem) => {
    const applicationId = context.rootGetters["main/getCurrentApplicationId"];
    const params = {
        type: "GET",
        url: apiItem.previousCommitId ? `/design/apis/${apiItem.id}/file?applicationId=${applicationId}&commitId=${apiItem.previousCommitId}`
            : `/design/apis/${apiItem.id}/file?applicationId=${applicationId}`
    };
    $http(params, true).then(
        data => context.commit("setDownloadFile", {
            data: (data && data.data ? data.data : data),
            headers: {
                contentType: data.headers["content-type"],
                contentDisposition: data.headers["content-disposition"]
            }
        }),
        error => console.log(error)
    );
};
export const renameExternalApi = (context, item) => {
    const params = {
        type: "POST",
        url: "/design/apis/rename",
        data: item
    };
    return $http(params, true);
};

export const renameExposedApi = (context, item) => {
    const params = {
        type: "POST",
        url: `/design/credentials/app/${item.appId}/id/${item.id}/rename`,
        data: item
    };
    return $http(params, true);
};

export const integrationURL = (context, item) => {
    const applicationId = context.rootGetters["main/getCurrentApplicationId"];
    const params = {
        type: "GET",
        url: `/design/apps/${applicationId}/apis/${item.apiId}/methods/${item.method}/endpoint`
    };
    return new Promise((resolve, reject) => {
        $http(params, true).then(
            data => resolve(data.data),
            error => reject(error)
        );
    });
};

export const recoverApi = (store, payload) => {
    const params = {
        url: "/design/apis/recover",
        type: "POST",
        data: payload
    };
    return $http(params, true).then(
        data => data,
        error => console.log(error)
    );
};
